<template>
	<div
		:id="`map-${_uid}`"
		:class="[
			'c-block-list-map-custom',
			'w-5col >=768:w-8col max-w-full mx-auto',
		]"
	>
		<LongReadTarget
			v-if="title"
			:container-id="`map-${_uid}`"
			:title="title"
		>
			<BaseH2 class="text-primary-button mb-md" v-text="title" />
		</LongReadTarget>

		<div
			:class="[
				'c-block-list-map-custom__content',
				'relative w-full',
				'rounded-md',
			]"
		>
			<div
				v-if="html"
				class="c-block-list-map-custom__map w-full"
				v-html="html"
			></div>
			<style v-if="css" v-html="css"></style>

			<PostScribeScript v-if="script" :html="script" />
		</div>
	</div>
</template>

<script>
import LongReadTarget from '~/citi-baseline/components/LongReadTarget';
import PostScribeScript from '~/citi-baseline/components/PostScribeScript';

export default {
	name: 'BlockListMapCustom',
	components: { LongReadTarget, PostScribeScript },
	inheritAttrs: false,

	props: {
		title: {
			type: String,
			required: false,
		},
		script: {
			type: String,
			default: '',
		},
		css: {
			type: String,
			default: '',
		},
		html: {
			type: String,
			default: '',
		},
	},
};
</script>

<style lang="postcss">
/*! purgecss start ignore */
/* Spot cleanup of styles */
.c-sweco__custom-wrapper,
:where(.c-block-list-map-custom__map) a,
:where(.c-block-list-map-custom__map) * {
	/* the 'a' in the :is() is important for it to have the proper specificity */
	all: revert;
}

/* Actually needed style overwrites */
.c-block-list-map-custom img {
	display: inline;
}

.c-block-list-map-custom__map > * {
	width: 100%;
	aspect-ratio: 16 / 9;
}

@screen <1024 {
	.c-block-list-map-custom__map > * {
		aspect-ratio: 1;
	}
}

.c-sweco__custom-wrapper {
	position: relative;
	box-sizing: border-box;
	padding-bottom: 100%;
	@apply overflow-hidden rounded-md;
}
@screen >=768 {
	.c-sweco__custom-wrapper {
		padding-bottom: calc((9 / 16) * 100%);
	}
}

#minimapbody,
.c-sweco__custom-wrapper .minimapbody {
	position: absolute;
}
/*! purgecss end ignore */
</style>
